import { BadgeDesignTokens } from '@primeuix/themes/types/badge';

export const BADGE_STYLES: BadgeDesignTokens = {
  colorScheme: {
    light: {
      // Darker than Aura's surface.100 so inactive tab counters stay legible against white.
      secondary: {
        background: '{surface.200}',
        color: '{surface.700}',
      },
    },
  },
};
